import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import Loading from "../../common/components/Loading";
import Box from "@mui/material/Box/Box";
import Grid from "@mui/material/Grid/Grid";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import DialogComponent from "../../common/components/DialogComponent";
import React, {useContext, useEffect, useRef, useState} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useAgGridLocale} from "../../../../config/globalConfig";
import {AgGridReact} from "ag-grid-react";
import {DialogInterface, SelectElementModelBE, SelectElementModelFE,} from "../../api/types/generic";
import {useActionColDef} from "../../utils";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import {DEFAULT_COL_DEF, SET_SNACKBAR} from "../../constants";
import dayjs from "dayjs";
import BasicToolbar from "../../common/components/BasicToolbar";
import useAgGridCustomHook from "../../hooks/useAgGridCustomHook";
import {locationDiscountColDef} from "./locationDiscountColDef";
import LocationDiscountFilters from "./LocationDiscountFilters";
import {
    FormSearchLocationDiscountModel,
    LocationDiscountEntityRequest,
    LocationDiscountEntityResponse,
    LocationDiscountFormModel,
    LocationDiscountGetData
} from "./Types/locationDiscount";
import {useLocationDiscountRepository} from "../../api/repositories/LocationDiscount";
import {Button, Dialog, DialogContent, IconButton, Tooltip, useTheme} from "@mui/material";
import {DeleteRounded} from "@mui/icons-material";
import BootstrapDialogTitle from "../../common/components/BootstrapDialogTitle";
import {FormProvider, useForm} from "react-hook-form";
import LocationDiscountForm from "./LocationDiscountForm";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {RateEntityResponse} from "../../api/types/rate";
import CustomLoader from "../../../../util/component/CustomLoader";

const LocationDiscount = () => {

    // Use Theme
    const theme = useTheme();

    // Use Context
    const {dispatchGlobalData, globalData: {user}} = useContext(GlobalContext);

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use AgGridLocale
    const agGridLocale = useAgGridLocale();

    // Use Ref
    const gridRef = useRef<AgGridReact>(null);

    // Use Repository Hooks
    const {
        getLocationDiscountPaged,
        getLocationDiscountDatas,
        postLocationDiscount,
        deleteLocationDiscount,
        downloadError
    } = useLocationDiscountRepository();

    // Use State
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [dialog, setDialog] = useState<DialogInterface | null>(null);
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [responseData, setResponseData] = useState<LocationDiscountGetData>()
    const [receivedResponse, setReceivedResponse] = useState(false)
    const [downloadResponse, setDownloadResponse] = useState()
    const [hideFirstButton, setHideFirstButton] = useState(false)
    const [initialValues, setInitialValues] = useState<LocationDiscountFormModel>({
        prcLocation: [],
        validityDateFrom: "",
        validityDateTo: "",
        pickUpDateFrom: "",
        pickUpDateTo: "",
        discountList: [],
        dealer: null,
        legalEntity: null,
        lppProfiles: []
    });

    //setto tutte le legalEntities options e le passo al filtro di ricerca ["all", "drivalia_it","drivalia_fr"]
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const everyLegalEntitiesWithoutAll = legalEntityOptions
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //setto tutti i dealers options
    const dealerOption: SelectElementModelFE[] = user.dealers?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const dealerFilteredOptions = dealerOption
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    const getResponseData = async () => {
        const responseData: LocationDiscountGetData = await getLocationDiscountDatas(everyLegalEntitiesWithoutAll, dealerFilteredOptions)
        setResponseData(responseData)
    }

    useEffect(() => {
        getResponseData()
    }, [])

    const [testFilters, setTestFilters] = useState<FormSearchLocationDiscountModel>({
        locationCodes: [],
        validityFrom: "",
        validityTo: "",
        pickUpDateFrom: "",
        pickUpDateTo: "",
        lppProfileIds: [],
        discounts: [],
        dealers: dealerFilteredOptions,
        legalEntities: everyLegalEntitiesWithoutAll
    })

    // Use Grid Data Custom Hook
    const {setServerSideDatasource, handleTriggerFilters, refresh} =
        useAgGridCustomHook<
            LocationDiscountEntityResponse,
            FormSearchLocationDiscountModel
        >({
            gridRef,
            api: getLocationDiscountPaged,
            initialSortColId: "locationCodes",
            entityFilters: testFilters,
            customSort: "LocationDiscountEntityResponse",
        });

    useEffect(() => {
        if (gridRef?.current)
            handleTriggerFilters({
                locationCodes: (testFilters.locationCodes as SelectElementModelFE[]).map(el => el.code as string) as string[],
                validityFrom: testFilters.validityFrom
                    ? dayjs(testFilters.validityFrom).toISOString()
                    : testFilters.validityFrom,
                validityTo: testFilters.validityTo
                    ? dayjs(testFilters.validityTo).toISOString()
                    : testFilters.validityTo,
                pickUpDateFrom: testFilters.pickUpDateFrom
                    ? dayjs(testFilters.pickUpDateFrom).toISOString()
                    : testFilters.pickUpDateFrom,
                pickUpDateTo: testFilters.pickUpDateTo
                    ? dayjs(testFilters.pickUpDateTo).toISOString()
                    : testFilters.pickUpDateTo,
                lppProfileIds: (testFilters.lppProfileIds as SelectElementModelFE[]).map(el => el.code as number) as number[],
                discounts: testFilters.discounts as number[],
                legalEntities:
                    ((testFilters.legalEntities as SelectElementModelFE)
                        ?.code as string) === "all"
                        ? everyLegalEntitiesWithoutAll
                        : ((testFilters.legalEntities as SelectElementModelFE[]).map(el => el.code as string)),
                dealers:
                    ((testFilters.dealers as SelectElementModelFE)
                        ?.code as string) === "all"
                        ? dealerFilteredOptions
                        : ((testFilters.dealers as SelectElementModelFE[]).map(el => el.code as string)),
            });
    }, []);

    useEffect(() => {
        handleTriggerResetFilters()
    }, [])

    const handleTriggerResetFilters = () => {
        setTestFilters({
            locationCodes: [],
            validityFrom: "",
            validityTo: "",
            pickUpDateFrom: "",
            pickUpDateTo: "",
            lppProfileIds: [],
            discounts: [],
            dealers: [],
            legalEntities: []
        });
        handleTriggerFilters({
            locationCodes: [],
            validityFrom: "",
            validityTo: "",
            pickUpDateFrom: "",
            pickUpDateTo: "",
            lppProfileIds: [],
            discounts: [],
            dealers: [],
            legalEntities: []
        });
    };

    const handleGetLocationDiscountList = () => {
        handleTriggerFilters({
            locationCodes: (testFilters.locationCodes as SelectElementModelFE[]).map(el => el.code as string) as string[],
            validityFrom: testFilters.validityFrom
                ? dayjs(testFilters.validityFrom).toISOString()
                : testFilters.validityFrom,
            validityTo: testFilters.validityTo
                ? dayjs(testFilters.validityTo).toISOString()
                : testFilters.validityTo,
            pickUpDateFrom: testFilters.pickUpDateFrom
                ? dayjs(testFilters.pickUpDateFrom).toISOString()
                : testFilters.pickUpDateFrom,
            pickUpDateTo: testFilters.pickUpDateTo
                ? dayjs(testFilters.pickUpDateTo).toISOString()
                : testFilters.pickUpDateTo,
            lppProfileIds: (testFilters.lppProfileIds as SelectElementModelFE[]).map(el => el.code as number) as number[],
            discounts: testFilters.discounts as number[],
            legalEntities:
                ((testFilters.legalEntities as SelectElementModelFE)
                    ?.code as string) === "all"
                    ? everyLegalEntitiesWithoutAll
                    : ((testFilters.legalEntities as SelectElementModelFE[]).map(el => el.code as string)),
            dealers:
                ((testFilters.dealers as SelectElementModelFE)
                    ?.code as string) === "all"
                    ? dealerFilteredOptions
                    : ((testFilters.dealers as SelectElementModelFE[]).map(el => el.code as string)),
        });
    };

    console.log(testFilters)

    // useEffect(() => {
    //     setTimeout(() => {
    //         handleGetLocationDiscountList();
    //     }, 500);
    // }, [i18n.resolvedLanguage]);

    const validationSchema = yup
        .object()
        .shape({
            validityDateFrom: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            validityDateTo: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            pickUpDateFrom: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            pickUpDateTo: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            minDiscount: yup
                .number()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            discountList: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .number()
                        .integer(t("pricing:alert.errors.integer"))
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                )
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            prcLocation: yup.array().of(
                yup.object().shape({
                    code: yup.string(),
                    label: yup.string()
                }))
                .min(1)
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            dealer: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string(),
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            legalEntity: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string(),
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            lppProfiles: yup.array().of(
                yup.object().shape({
                    code: yup.string(),
                    label: yup.string()
                }))
                .min(1)
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        })
        .defined();

    // Use Form
    const form = useForm<LocationDiscountFormModel>({
        defaultValues: initialValues,
        resolver: yupResolver(
            validationSchema,
            {},
            {
                rawValues: true,
            }
        ),
        shouldUnregister: true,
    });

    const {actionColDef} = useActionColDef();
    const columnDefs: ColDef<LocationDiscountEntityResponse>[] = locationDiscountColDef(
        {
            actionsRenderer: (params: ICellRendererParams) => (
                <Tooltip arrow title={t("pricing:tooltips.delete")} placement={"right-start"}>
                    <IconButton
                        aria-label="delete"
                        onClick={() => deleteButtonClicked(params.data)}
                        color="accent"
                        sx={{
                            margin: "auto",
                            color: theme.palette.accent.main
                        }}
                    >
                        <DeleteRounded/>
                    </IconButton>
                </Tooltip>
            ),
            actionColDef,
            user
        }
    );

    const defaultColDef = DEFAULT_COL_DEF;

    const toolbar = {
        renderActions: () => (
            <BasicToolbar
                addIcon={
                    !!user.profiles.find((profile: any) => {
                        return profile.auths.find((auth: any) => {
                            return auth.name === "SCOPE_PRC_CREATE_UPSELLING_RATE";
                        });
                    })
                        ? {
                            onClick: () => setOpenDialog(true)
                        }
                        : undefined
                }
            />
        ),
    };

    const handleConfirmSave = async () => {
        const watchAllForm = form.getValues();
        const request: LocationDiscountEntityRequest = {
            locationCodes: watchAllForm.prcLocation.map(el => el.code) as string[],
            validityDateFrom: watchAllForm.validityDateFrom ? dayjs(watchAllForm.validityDateFrom).toISOString() : "",
            validityDateTo: watchAllForm.validityDateTo ? dayjs(watchAllForm.validityDateTo).toISOString() : "",
            pickUpDateFrom: watchAllForm.pickUpDateFrom ? dayjs(watchAllForm.pickUpDateFrom).toISOString() : "",
            pickUpDateTo: watchAllForm.pickUpDateTo ? dayjs(watchAllForm.pickUpDateTo).toISOString() : "",
            discountList: watchAllForm.discountList,
            dealer: dealerFilteredOptions.length === 1 ? dealerFilteredOptions[0] : (watchAllForm.dealer as SelectElementModelFE)?.code as string,
            legalEntity: legalEntityOptions.length === 1 ? everyLegalEntitiesWithoutAll[0] : (watchAllForm.legalEntity as SelectElementModelFE)?.code as string,
            idProfiles: watchAllForm.lppProfiles.map(el => ({
                id: el.code as number,
                label: el.label as string
            })),
        }
        const locationCodes = await form.trigger("prcLocation")
        const validityDateFrom = await form.trigger("validityDateFrom")
        const validityDateTo = await form.trigger("validityDateTo")
        const pickUpDateFrom = await form.trigger("pickUpDateFrom")
        const pickUpDateTo = await form.trigger("pickUpDateTo")
        const discountList = await form.trigger("discountList")
        const dealer = await form.trigger("dealer")
        const legalEntity = await form.trigger("legalEntity")
        const idProfiles = await form.trigger("lppProfiles")
        await setIsLoading(true);
        if (locationCodes && validityDateFrom && validityDateTo && pickUpDateFrom && pickUpDateTo && discountList && dealer && legalEntity && idProfiles) {
            try {
                const response = await postLocationDiscount(request)
                setDownloadResponse(response)
                dispatchGlobalData(SET_SNACKBAR.SUCCESS);
                if (response.data.byteLength != 0) {
                    setReceivedResponse(true)
                    setHideFirstButton(true)
                } else {
                    setReceivedResponse(false)
                    setHideFirstButton(true)
                }
            } catch (e) {
                console.log(e)
            }
        }
        setIsLoading(false);
    }

    const handleConfirmCloseDialog = async () => {
        await setIsLoading(true);
        setReceivedResponse(false)
        setHideFirstButton(false)
        setOpenDialog(false)
        refresh()
        setIsLoading(false);
        dispatchGlobalData(SET_SNACKBAR.SUCCESS);
    }

    const handleConfirmDownload = async () => {
        await setIsLoading(true);
        try {
            await downloadError(downloadResponse)
            setReceivedResponse(false)
            setHideFirstButton(false)
            setOpenDialog(false)
            refresh()
            dispatchGlobalData(SET_SNACKBAR.SUCCESS);
        } catch (e) {
            setReceivedResponse(false)
            setHideFirstButton(false)
            console.log(e)
        }
        setIsLoading(false);
    }

    const handleConfirmDelete = async (id: number) => {
        try {
            if (id) {
                await deleteLocationDiscount(id);
                setDialog(null);
                refresh();
                dispatchGlobalData(SET_SNACKBAR.SUCCESS);
            }
        } catch (e) {
        }
    };

    const deleteButtonClicked = (data: RateEntityResponse) => {
        setDialog({
            open: true,
            onClickConfirm: () => handleConfirmDelete(data.id),
            message: t("pricing:locationDiscount.delete"),
        });
    };

    const closeDialog = () => {
        setOpenDialog(false)
        setReceivedResponse(false)
        setHideFirstButton(false)
    }

    return (
        <Box>
            <SectionHeader
                title={t("translation:auths.SCOPE_PRC_VIEW_LOCATION_DISCOUNT.name")}
            />

            <LocationDiscountFilters
                handleGetLocationDiscountList={handleGetLocationDiscountList}
                handleClickResetSearch={handleTriggerResetFilters}
                testFilters={testFilters}
                setTestFilters={setTestFilters}
                responseData={responseData as LocationDiscountGetData}
            />

            <Grid container spacing={2} p={2}>
                <Grid item xs={12} sm={12}>
                    <AgGridCustomTable
                        gridRef={gridRef}
                        toolbar={toolbar}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}
                        pagination
                        localeText={agGridLocale}
                        tooltipShowDelay={0}
                        domLayout="autoHeight"
                        rowModelType="serverSide"
                        paginationPageSize={10}
                        cacheBlockSize={10}
                        serverSideInfiniteScroll
                        onGridReady={setServerSideDatasource}
                    />
                    {dialog?.open && (
                        <DialogComponent
                            type={"info"}
                            onClickConfirm={dialog.onClickConfirm}
                            setOpen={() => setDialog(null)}
                            open={dialog.open}
                            message={dialog.message}
                        />
                    )}
                </Grid>
            </Grid>

            <Dialog open={openDialog} maxWidth={"xl"} fullWidth>
                <BootstrapDialogTitle id="customized-dialog-title" end={'end'}
                                      onClose={closeDialog}></BootstrapDialogTitle>
                <DialogContent style={{color: theme.palette.primary.main}}>
                    <FormProvider {...form}>
                        <LocationDiscountForm/>
                    </FormProvider>
                    {!hideFirstButton && <div style={{display: "flex", justifyContent: "end", alignItems: "end"}}>
                        <Button type="submit" style={{marginLeft: "15px"}} size="small"
                                onClick={handleConfirmSave}>{t("pricing:actions.confirm")}</Button>
                    </div>}
                    {!receivedResponse && hideFirstButton &&
                        <div style={{display: "flex", justifyContent: "end", alignItems: "end"}}>
                            <Button type="submit" style={{marginLeft: "15px"}} size="small"
                                    onClick={handleConfirmCloseDialog}>{t("pricing:actions.saveAndExit")}</Button>
                        </div>
                    }
                    {receivedResponse && hideFirstButton &&
                        <div style={{display: "flex", justifyContent: "end", alignItems: "end"}}>
                            <Button type="submit" style={{marginLeft: "15px"}} size="small"
                                    onClick={handleConfirmDownload}>{t("pricing:actions.saveAndDownload")}</Button>
                        </div>
                    }
                </DialogContent>
            </Dialog>

            <CustomLoader loading={isLoading}/>
        </Box>
    );
};

export default LocationDiscount;
